import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
  activeMenu: '',
  mainNavStatus: false,
  // Track Characteristics: values for "stroke"
  // OPACITY is defined as fourth para, of the color value, so no extra setting!
  // tailwind's green-600: [5, 150, 105, 1], // or HEX: '#059669', or 'rgba(...)'
  // Yellow: [240, 220, 150, 0.8]
  trackStrokeColor: [151, 38, 109, 1], // tailwind's pink-800
  trackStrokeLineCap: 'round',
  trackStrokeWidth: 5,
  // Position Point characteristics
  positionType: 'Circle',
  positionRadius: 8, // works only with Circle
  positionFillColor: '#9D174D', // tailwind's pink-800
  positionStrokeColor: 'transparent',
  positionStrokeWidth: 2,
  // Position Accuracy Circle Characteristics
  // Orange: [151, 38, 109, 1]
  // Start Point Characteristics
  // End Ppoint Characteristics
  // Colors
  primary: '',
  secondary: '',
  info: '',
  success: '',
  warning: '',
  error: ''
}

export default {
  state,
  mutations,
  actions,
  getters
}

/* CSS HEX * /
--navy-blue: #03045eff;
--dark-cornflower-blue: #023e8aff;
--star-command-blue: #0077b6ff;
--blue-green: #0096c7ff;
--cerulean-crayola: #00b4d8ff;
--sky-blue-crayola: #5bcfe6ff;
--sky-blue-crayola-2: #90e0efff;
--blizzard-blue: #ade8f4ff;
--powder-blue: #caf0f8ff;

/ * CSS HSL * /
--navy-blue: hsla(239, 94%, 19%, 1);
--dark-cornflower-blue: hsla(214, 97%, 27%, 1);
--star-command-blue: hsla(201, 100%, 36%, 1);
--blue-green: hsla(195, 100%, 39%, 1);
--cerulean-crayola: hsla(190, 100%, 42%, 1);
--sky-blue-crayola: hsla(190, 74%, 63%, 1);
--sky-blue-crayola-2: hsla(189, 75%, 75%, 1);
--blizzard-blue: hsla(190, 76%, 82%, 1);
--powder-blue: hsla(190, 77%, 88%, 1);

/ * SCSS HEX * /
$navy-blue: #03045eff;
$dark-cornflower-blue: #023e8aff;
$star-command-blue: #0077b6ff;
$blue-green: #0096c7ff;
$cerulean-crayola: #00b4d8ff;
$sky-blue-crayola: #5bcfe6ff;
$sky-blue-crayola-2: #90e0efff;
$blizzard-blue: #ade8f4ff;
$powder-blue: #caf0f8ff;

/ * SCSS HSL * /
$navy-blue: hsla(239, 94%, 19%, 1);
$dark-cornflower-blue: hsla(214, 97%, 27%, 1);
$star-command-blue: hsla(201, 100%, 36%, 1);
$blue-green: hsla(195, 100%, 39%, 1);
$cerulean-crayola: hsla(190, 100%, 42%, 1);
$sky-blue-crayola: hsla(190, 74%, 63%, 1);
$sky-blue-crayola-2: hsla(189, 75%, 75%, 1);
$blizzard-blue: hsla(190, 76%, 82%, 1);
$powder-blue: hsla(190, 77%, 88%, 1);

/ * SCSS RGB * /
$navy-blue: rgba(3, 4, 94, 1);
$dark-cornflower-blue: rgba(2, 62, 138, 1);
$star-command-blue: rgba(0, 119, 182, 1);
$blue-green: rgba(0, 150, 199, 1);
$cerulean-crayola: rgba(0, 180, 216, 1);
$sky-blue-crayola: rgba(91, 207, 230, 1);
$sky-blue-crayola-2: rgba(144, 224, 239, 1);
$blizzard-blue: rgba(173, 232, 244, 1);
$powder-blue: rgba(202, 240, 248, 1);

/ * SCSS Gradient * /
$gradient-top: linear-gradient(0deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-right: linear-gradient(90deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-bottom: linear-gradient(180deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-left: linear-gradient(270deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-top-right: linear-gradient(45deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-bottom-right: linear-gradient(135deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-top-left: linear-gradient(225deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-bottom-left: linear-gradient(315deg, #03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
$gradient-radial: radial-gradient(#03045eff, #023e8aff, #0077b6ff, #0096c7ff, #00b4d8ff, #5bcfe6ff, #90e0efff, #ade8f4ff, #caf0f8ff);
*/
